import { cn } from "@wags/ui/ui-utils";
import { LinkGlyph } from "./glyphs";
import { normalizeExternalUrl } from "../external-url";

export function ProviderWebsiteLink({
    website,
    className,
}: {
    website: string | null | undefined;
    className?: string;
}) {
    if (!website) return null;
    const href = normalizeExternalUrl(website);
    if (!href) return null;
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer noopener"
            className={cn(
                "inline-flex items-center gap-1.5 rounded text-body-small font-medium text-secondary-copper underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow [@media(hover:hover)]:hover:text-chocolate-lab",
                className,
            )}
        >
            <LinkGlyph className="size-3.5 shrink-0" />
            Visit their website
        </a>
    );
}
